export default {
  activationCode:
    "Please enter the 6-digit activation you received from the OneDine Portal",
  activationCodeErrorHeading: "Oops!",
  activationCodeErrorMessage: "Something seems to be wrong.",
  activationLoadingHeading: "Activating",
  activationLoadingMessage: "This should only take a moment.",
  networkError:
    "Unable to connect to the OneDine server. Please check the network and try again",
  reset: "Reset",
  retry: "Retry",
  rethinkConnectionError: "Error connecting to sync service",
  orderInProgress: "In Progress",
  openOrders: "Open",
  curbSideOrder: "Curbside",
  onlineOrder: "Online",
  walkUpMode: "Walk up",
  textToPayMode: "Call in",
  orderType_scanToPay: "Scan to pay",
  orderType_POS: "POS",
  orderType_Table: "Table",
  orderType_Tab: "Tab",
  kioskMode: "Kiosk",
  table: "Table",
  sectionSeat: "SEAT",
  futureOrder: "Future",
  orderComplete: "Complete",
  cancelOrderText: "Cancelled",
  orderError: "Error",
  orderAbandoned: "Abandoned",
  cancelText: "Cancel",
  textToPayGenLoader: "Generating text to pay",
  payNowLoader: "Processing request",
  checkInRequestLoader: "Processing request",
  phnNumberText: "Phone: ",
  checkInNote: "Check in: ",
  notificationApprove: "APPROVE",
  notificationReject: "REJECT",
  notificationAcknowledge: "ACK",
  notificationDismiss: "DISMISS",
  notificationGoAndDismiss: "GO & DISMISS",
  sales: "SALES",
  taxLabel: "TAX",
  fireboardTip: "TIP",
  fireboardTipInPercent: "TIP %",
  checkOpen: "OPEN:",
  checkClosed: "CLOSED:",
  itemCount: "ITEM #",
  order: "ORDER:",
  getStoreBookingsLoader: 'Getting store bookings',
  orderReady: "Ready",
  ackIdCheck: "Acknowleding ID Check",
  ackOverServe: "Acknowleding Over Serve",
  getFutureOrders: 'Getting future orders',
  getFutureOrderSummary: 'Getting future order summary',
  cancelCheckHeading: 'Are you sure you want to cancel the order ?',
  cancelCheckHeadingAlt: 'Are you sure you want to cancel the order ? This action will ONLY cancel from the Fireboard. This action will NOT cancel from the POS and NOT process a refund. ',
  orderCancellation: 'Order Cancellation',
  yes: 'Yes',
  no: 'No',
  getStoreTagsLoader: 'Getting store tags',
  channelUpdateStatus: "Update Channel Status :",
  updateChannelSettings: 'Update Channel Settings',
  channelSettings: "Channel Settings ",
  channelsUpdateTimeRate: "Update Time/Rate :",
  channelsPrepTime: "Preparation Time :",
  channelsProductionRate: "Production Rate :",
  channelsUpdate: "Update",
  futureToIPHeader: 'Update Order Status',
  futureToIPMessage: 'Are you sure you want to move the order to In Progress?',
  totalDueWithoutDollar: 'TOTAL DUE',
  yesCaps: 'YES',
  noCaps: 'NO',
  memberDetails: "Member Details",
  firstName: "First Name:",
  lastName: "Last Name:",
  phoneNumber: "Phone Number:",
  emailAddress: "Email Address:",
  updateOrderLoading: 'Updating the order status',
  confirmationMessage: 'Confirmation Message',
  bookingDetails: "Booking Details",
  partySize: "Party Size",
  bookingTime: "Booking Time",
  numberLabel: "number",
  textLabel: "text",
  emailLabel: "email",
  // tmsCounterHeading: "Of your guests, how many are children ?",
  tmsCounterHeading: "Number of Children",
  guest: "+ GUEST",
  addGuest: "ADD GUEST",
  awlCancel: "CANCEL",
  awlAdd: "ADD",
  availableSlots: "Available Times",
  slotsNotAvaialable: "There are no available times for this wait list. Please change criteria and try again",
  reserve: "RESERVE",
  search: "SEARCH",
  okayText: "OK",
  updateText: "UPDATE",
  edit: "EDIT",
  delete: "DELETE",
  sendSmsMessage:
    'This will send a message to the guest at {{phoneNumber}}.Do you want to continue?',
  smdSendLoaderHeading: 'Sending SMS',
  send: 'SEND',
  printLoading: 'Printing data',
  printWithStation: 'Printing data at',
  sync: 'Syncing with your POS',
  syncingCheck: 'Syncing check with POS',


  activationCode: 'Please enter the 6-digit activation you received from the OneDine Portal',
  watchActivationCode: 'Please enter the 6-digit code from the watch ',
  activationCodeErrorHeading: 'Oops!',
  activationCodeErrorMessage: 'Something seems to be wrong.',
  activationLoadingHeading: 'Activating',
  activationLoadingMessage: 'This should only take a moment.',

  // Login screen
  loginLoadingHeading: 'Logging in',
  logoutLoadingHeading: 'Logging out',
  preAuthLoadingHeading: 'Getting pre auth data',
  cardLoadingMessage: 'Please swipe your card after the beep',
  swipeCardMsg: 'Please swipe your card',
  loginLoadingMessage: 'This should only take a moment.',
  reset: 'Reset',
  retry: 'Retry',
  ok: 'OK',
  exit: 'Exit',
  supportServerApp: 'Application is not enabled. Please contact support',
  development: 'DEVELOPMENT',
  developmentFB: 'DEV',
  clear_all: 'CLEAR ALL',
  tapToSwipeCard: 'Tap here to Swipe',

  paymentSuccess: "You're all done!",
  paymentFailed: 'Payment Failed',
  orderFailed: 'Order Failed',
  thankyou: 'Thank you! Come back soon.',
  emailEnter: 'Please enter your email address:',
  phoneNumberEnter: 'Please enter your phone number:',
  standardRates: 'Standard text messaging rates apply.',
  done: 'DONE',
  customTipDone: 'ADD TIP',
  paymentTo: 'Your payment to',
  feedbackQuestion: 'How was your overall experience today?',
  CustomTipChange: 'CHANGE',
  CustomTipConfirm: 'CONFIRM',

  // Dashboard screen
  sync: 'Syncing with your POS',
  menuSync: 'Syncing menu',
  addTable: 'Table already added',
  tableAlreadyExists: 'Table already added by another server',
  tableDoesNotExist: "Table doesn't exist",
  tableBelongsToOther: 'Table belongs to another employee',
  tableText: 'ENTER TABLE #', // me
  tabModeText: 'ENTER TAB NAME',
  tips: 'TIPS',
  tableModeButtonText: 'TABLE',
  tab: 'TAB',
  dashboardStatus: 'STATUS',
  dashboardStation: 'TABLE',
  dashboardMessage: 'MESSAGE',
  dashboardAction: 'ACTION',
  clockOut: 'CHANGE ROLE',
  clockoutMessage: 'This will log you out, continue ?',
  clockInRequiredCode: 'employee_clock_in_required',
  clockInRequired: 'Clock in is required, continue ?',
  selectJob: 'Select a job',
  fetchingJobs: 'Fetching Jobs',
  clockingYouOut: 'Changing role',
  jobListClockIn: 'SELECT A ROLE',

  // Menu screen
  enterNotes: 'Enter Notes',
  goToMenu: 'Go To Menu',

  // Menu Selector
  callServerSuccess: 'Your server has been notified.',
  callServer: 'CALL SERVER',
  payOrder: 'PAY ORDER',
  confirmOrder: "I'M STILL HERE",
  paymentApproved: 'PAYMENT APPROVED',

  // PayByCash screen
  confirm: 'PAY',

  noPayOnUnfired: 'Payment cannot be made when check has unsent items',

  // Payment landing screen
  tipMessage: 'How much would you like to tip?',
  tipHeading: 'Please enter a tip amount below or select a tip option on the right',
  pay: 'PAY',
  subTotalLabel: 'SUBTOTAL',
  taxLabel: 'TAX',
  split: 'SPLIT',
  viewMyCheck: 'VIEW MY CHECK',
  payFull: 'PAY FULL AMOUNT',
  splitPay: 'SPLIT WITH OTHERS',
  payAmount: 'PAY AN AMOUNT',
  multipleTender: 'USE MORE THAN ONE FORM OF PAYMENT',
  selectItems: 'SELECT ITEMS TO PAY',
  payFullCheck: 'PAY FULL CHECK',
  payWithCash: 'PAY WITH CASH',
  payWithGiftCard: 'GIFT CARD',
  payWithCreditCard: 'PAY WITH CREDIT CARD',
  creditCard: 'CREDIT CARD',
  payOnPhone: 'Prefer to pay on your phone?',
  scanQR: 'Scan this code to download OneDine.',
  other: 'OTHER',
  splitByAmount: "You can't pay more than the check amount",
  splitByAmountErrorPopup: 'Please enter a valid amount',
  amountEqualsZero: 'Please enter an amount greater than zero',

  // PaymentSignature screen
  noReceipt: 'NO RECEIPT',
  paperReceipt: 'PAPER RECEIPT',
  emailReceipt: 'EMAIL RECEIPT',
  textReceipt: 'TEXT RECEIPT',
  paper: 'paper',
  receipt_receive_instructions: 'Please select how you would like to receive your receipt',
  PaymentSignature: 'SIGNATURE',

  tipInPercent: 'CUSTOM TIP PERCENT',
  tipInAmount: 'CUSTOM TIP AMOUNT',
  newAmount: 'NEW CHECK TOTAL WITH TIP',
  generateReceipt: 'Generating receipt',
  signatureUpload: 'Completing payment',
  subTotal: 'SubTotal',
  tax: 'Tax',
  paymentTotal: 'Total',
  paidAmount: 'Paid Amount',
  tip: 'Tip',
  charity: 'Charity',
  uploadSignaturePopup: 'Completing payment',
  signaturePaymentDone: 'Done',
  chargedTo: 'CHARGED TO',
  endingIn: 'ENDING IN',
  paymentAgreement: 'I agree to pay the total amount according to my card issuer agreement.',
  PaymentCanceledByGuest: 'Payment canceled by guest',
  clearSignature: 'CLEAR SIGNATURE',

  // tip modal
  percent: 'PERCENT',
  percentMessage: 'Tip this percentage of the subtotal:',
  percentMessageTotal: 'Tip this percentage of the total:',
  tipInDollar: 'Please enter amount you would like to tip:',
  amount: 'AMOUNT',
  amountMessage: 'Tip this amount:',
  total: 'TOTAL',
  totalMessage: 'Including tip, I want to pay a total of:',
  errorMessage: 'Please enter valid tip',
  paymentDone: 'DONE',
  paymentStarted: ' CHARGED TO ',
  paymentEnding: ' ENDING IN ',

  // split modal
  people: 'PEOPLE',
  splitPeople: 'Please select how many people will split this check:',
  splitAmount: 'Pay this amount towards the balance:',
  cancel: 'CANCEL',
  personPays: 'Each person pays',

  // PlayGround screen
  something: 'SOMETHING',
  clickMe: 'Click me!',

  // StagePayment Screen
  StagePaymentAdd: 'STAGE',
  seats: 'Seats',
  bill: 'Check',
  stagePaymentContinue: 'DONE',
  stagePaymentTotal: 'TOTAL',
  stagePaymentPriceZero: 'Cannot add the seat, since total price is zero',
  printPopupHeader: 'Select an option to print',
  selectPrinter: 'Select a printer',
  selectGuestReceiptPrinter: 'Select guest receipt printer',
  stages: 'Stages',
  changePrinter: 'Change Printer',

  selectJobGroup: 'Select a station',
  // PaymentInsertCard screen
  payingTo: 'YOUR PAYMENT TO',
  insertCard: 'Insert card',
  reInsertCard: 'Re-Insert card',
  chipFailedSwipe: 'Please insert card',
  swipeCard: 'Swipe  card',
  reSwipeCard: 'Please swipe card again',
  swipeTapCard: 'Swipe or Tap card',
  swipeNotAllowed: 'Please insert the card. Swipe is not supported',
  removeCard: 'Remove Card',
  payPreference: 'Prefer to pay on your phone?',
  scanToPay: 'Scan this code to download OneDine',
  payByCash: 'Pay by cash',
  initialize: 'Establishing secure payment connection',
  initializePayment: 'Activating card reader',
  continueButtonLabel: 'PAY',
  creditCardButton: 'CREDIT CARD',
  cashButton: 'CASH',
  paymentInsertCard_heading: 'Initializing payment',
  paymentInsertCard_initializing: 'Initializing',
  paymentInsertCard_Unable_to_detect_location: 'Unable to detect location. Please try again',
  paymentInsertCard_Device_setup_done: 'Device setup completed.',
  paymentInsertCardHeading: 'Please review your check and press pay to continue.',
  tapFailed: 'Tap failed. Please insert card or swipe.',
  postingPayment: 'Sending Order',

  noCardReader: 'Card reader unavailable. Please try again.',
  // onDeviceSetUp
  setUpDevice: 'Setting up card reader',
  setUpComplete: 'Card reader setup completed.',
  downloadFirmWare: 'Downloading firmware',
  updateFirmWare: 'Updating firmware',

  // tableDetails component
  move_to: 'MOVE TO',
  remvoe: 'REMOVE',
  info: 'INFO',
  menu: 'MENU',
  scan: 'SCAN',
  select: 'SELECT',
  move: 'MOVE',
  print: 'PRINT',
  cash: 'CASH',
  credit: 'CREDIT',
  paymentButton: 'PAYMENT',
  stage: 'STAGE',
  seat: 'SEAT',
  repeat: 'REPEAT',
  fire: 'SEND',
  yes: 'Yes',
  no: 'No',
  openingCheck: 'Opening check on the POS',
  preparingTable: 'Preparing table',
  occupyingSeat: 'Occupying seat',
  updatingSeat: 'Updating seat',
  clearingSeat: 'Clearing seat',
  creatingOrder: 'Sending order to the POS',
  addingUnfired: 'Adding to cart',
  removingUnfired: 'Removing from cart',
  printOptionDisabled: 'Print receipt is not supported',
  processingPayment: 'Processing payment',
  checkInvalid: 'Check invalid',
  noLocation: 'Unable to detect location',
  clearSeatPopupHeading: 'Are you sure?',
  clearSeatPopupMessage:
    'This will delete the pending items and move all fired items from this seat to the table.',
  occupySeatPopupMessage: 'At least one seat must be occupied',
  pendingItemsPopupMessage: 'Please select pending items to order',
  beverageValidationPopupMessage: 'Please select beverages for all entrees',
  paymentNotAllowed: 'Payment is not allowed',
  // paymentNotAllowed: 'Payment cannot be made when check has unsent items',
  fireItemsPopupMessage: 'Please send all unsent items to proceed',
  selectItemPopupMessage: 'Please select at least one item',
  menuItemMoveToPopupMessage: 'You can move only after you send all items.',
  cannotMovePendingItems: 'You cannot move unsent items.',
  cannotPrintWithUnfired: 'You cannot print with unfired items',
  clearChairPopupMesage: 'You cannot clear this seat',
  checkOrderItemPopUpMessage:
    'This item was ordered on the POS and cannot be repeated. Please order on the POS.',
  itemInactivePopupMessage:
    'Action cannot be done with these item(s), as they have inactive item(s)',
  sendOptionsMessage: 'Please select any send option.',
  sendToGo: 'Send TO-GO',
  sendDoNotMake: 'Send DO-NOT-MAKE',
  sendOnTheFly: 'Send ON-THE-FLY',
  cancelSendOptions: 'CANCEL',

  // ChairConfig
  male: 'MALE',
  female: 'FEMALE',
  child: 'CHILD',
  birthDay: 'BIRTHDAY',
  anniversary: 'ANNIVERSARY',
  graduation: 'GRADUATION',
  babyShower: 'BABY SHOWER',
  bachelor: 'BACHELOR',
  bridalShower: 'BRIDAL SHOWER',
  all: 'ALL',
  fromStart: 'FROM START',
  fromArrival: 'FROM ARRIVAL',

  //  AddChairPopupContent
  shareTableOrders: 'SHARE TABLE ORDERS',
  clearSeat: 'CLEAR SEAT',

  // PaymentFinalize screen
  PaymentFinalize_PaymentSuccess: "You're all done!",
  PaymentFinalize_Thankyou: 'Thank you! Come back soon.',
  PaymentFinalize_HandToNextGuest: 'Please Hand It To Next Guest',
  PaymentFinalize_Continue: 'CONTINUE',
  PaymentFinalize_PaymentDone: 'DONE',
  PaymentFinalize_Cancel: 'CANCEL',
  PaymentFinalize_CashToServer: 'Please pay cash directly to your server.',
  PaymentFinalize_CashPaymentOf: 'Cash payment of',
  PaymentFinalize_DueFromSeats: 'due from seats',

  // stagePaymentFinalize screen
  StagePaymentFinalize_PaymentSuccess: "You're all done!",
  StagePaymentFinalize_Thankyou: 'Thank you! Come back soon.',
  StagePaymentFinalize_HandToNextGuest: 'Please Hand It To Next Guest',
  StagePaymentFinalize_Continue: 'CONTINUE',
  StagePaymentFinalize_PaymentDone: 'DONE',
  StagePaymentFinalize_Cancel: 'CANCEL',
  StagePaymentFinalize_CashToServer: 'Please pay cash directly to your server.',
  StagePaymentFinalize_CashPaymentOf: 'Cash payment of',
  StagePaymentFinalize_DueFromSeats: 'due from seats',

  // PaymentError screen
  PaymentError_Heading: 'Payment failed',

  // bottomBar Component
  modify: 'Modify',
  doneButton: 'Done',
  page: 'PAGE',
  of: 'OF',

  // modifier Component
  modifierBack: 'Back', // me

  // feedBackButtonConfig
  oneDine: 'OneDine',
  waitTime: 'Wait Time',
  ambience: 'Ambience',
  cleanliness: 'Cleanliness',
  service: 'Service',
  food: 'Food',

  // header component
  clockIn: 'CLOCK-IN',
  nextBreak: 'NEXT BREAK',
  dashBoard: 'Dashboard',
  onedineLable: 'onedine',
  logIn: 'Log In',
  logOut: 'Log Out',
  back: 'Back',

  // keyPad Component
  backspace: 'backspace',

  // popup
  errorPopupHeading: 'Oops',
  errorPopupMessage: 'Error',
  successHeading: 'Success',
  successMessage: 'success',
  loading: 'Loading',
  loadingPopupMessage: 'This should only take a moment.',

  // serverTable
  status: 'STATUS',
  station: 'STATION',
  message: 'MESSAGE',
  action: 'ACTION',
  visit: 'visits this month.',
  allergies: 'Allergies',
  dismiss: 'DISMISS',
  table: 'Table',
  quit: 'QUIT',

  // surveyError component
  surveyError: 'Sorry, we were unable to process your payment. Please try again.',
  retryLabel: 'RETRY',
  paymentError: 'PAYMENT ERROR',

  // surveyPopup component
  paymentApproved: 'APPROVED | REMOVE CARD',
  processing: 'PROCESSING...',
  feedBackQue: 'What did you enjoy most?',
  // signature: 'TIP & SIGN',
  signature: 'SIGN',
  screen_tip: 'TIP',
  signatureReceipt: 'RECEIPT',
  suggestion: 'What can be improved?',
  experience: 'How was your overall experience today?',
  // swipeableMenuItem
  remove: 'REMOVE',
  edit: 'MODIFY',

  // tableList component
  tableLabel: 'TABLE',

  // Payment Gateway Test //me
  initializePaymentGateway: 'Initialize Payment Gateway',
  testPayment: 'Test Payment',
  uploadSignature: 'Upload Signature',

  // Blip Component
  blipText: 'M',

  // BottomBar component
  bottomBarModify: 'Modify',
  bottomBarDone: 'Done',

  // Chair component
  addChair: '+',

  // Counter Component

  counterMinus: ' - ',
  counterAdd: ' + ',

  // noteModalContent
  bookingInstruction: 'Special cooking instructions:',
  Type_here: 'Type here...',

  // PopupContentWrapper
  PopupContentWrapper_phone_error: 'Please enter a valid phone number.',
  PopupContentWrapper_email_error: 'Please enter a valid email address.',
  errorPopupDefaultMessage: 'request failed',
  // TableManager
  tableManager_are_you_sure: 'Are you sure?',
  tableManager_this_will_clear_the_seat: 'This will clear the seat.',

  // Card detail
  method: 'Method: ',
  card_detail_total: 'Total: ',
  card_type: 'CardType: ',
  card_detail_tip: 'Tip: ',
  card_number: 'Card #: ',
  card_detail_payment: 'Payment: ',
  card_detail_refund: 'Refund: ',
  name: 'Name: ',
  expirationDate: 'Expiration: ',
  paymentStatus: 'Payment Status: ',
  paymentStatusError: 'Error',
  paymentStatusPending: 'Pending',
  ticketTypeId: 'Ticket Type: ',
  refund: 'Refund',
  payment: 'Payment',
  card_detail_receipt: 'RECEIPT',
  card_detail_changeCard: 'CHANGE CARD',
  repost_pos: 'REPOST POS',
  business_date: 'Business Date: ',
  check_number: 'Check #:',
  check_server: 'Server: ',

  // Check History
  checkHistoryNumber: 'Number',
  checkHistoryTableNumber: 'Table',
  checkHistoryOpen: 'Open',
  checkHistoryOpenedTime: 'Opened at',
  checkHistoryClosedTime: 'Closed at',
  checkHistorySubtotal: 'Subtotal',
  checkHistoryTax: 'Tax',
  checkHistoryTotal: 'Total',
  checkHistoryUnpaid: 'Unpaid',
  checkHistoryPaid: 'Paid',
  CheckHistoryTip: 'Tip',
  CheckHistoryTipAmount: 'Tip',

  // Insert card payment code messages
  applicationSelectionCompleted: 'Application selection completed',
  gettingOnlineAuthorization: 'Getting online authorization',
  updatingTansaction: 'Updating transaction',
  gettingCardVerification: 'Getting card verification',
  paymentSuccessful: 'Payment successful',
  paymentCancelled: 'Payment cancelled',
  AuthorizationSuccessful: 'Authorization successful',

  // PaymentError screen
  paymentErrorHeading: 'Payment failed',
  paymentErrorMessage: 'Please contact your server.',

  surveyHeader: 'Please answer a brief survey while your payment is processing',
  surveyText: 'Please answer a brief survey',

  networkError: 'Unable to connect to the OneDine server. Please check the network and try again',
  timeoutError: 'There was an error connecting to the network',
  rethinkError: 'Error connecting. Please logout and login.',

  emailReceiptSpinner: 'Generating email receipt',
  emailReceiptError: 'Error in generating email receipt',
  smsReceiptSpinner: 'Generating sms receipt',
  smsReceiptError: 'Error in generating sms receipt',
  printReceiptSpinner: 'Printing receipt',
  printReceiptError: 'Error in printing receipt',

  paymentText: 'Payment',

  diagnostics: 'Diagnostics',
  diagnosisTest: 'Test',
  diagnosisValue: 'Status',
  diagnosisResult: 'Result',

  online: 'Online',
  offline: 'Offline',

  stageMacro: 'GOING DUTCH',

  // Diagnostics
  testPass: 'pass',
  testFail: 'fail',
  testPending: 'pending',
  networkPing: 'Network',
  ODPing: 'OneDine',
  RTDBConnection: 'Sync',
  deviceStatus: 'Card reader',
  omnivoreStoreStatus: 'Omnivore',
  posSystemStatus: 'POS System',
  deviceActivation: 'Device activated',
  DiagnosticSync: 'Server Sync',
  AppSync: 'App Sync',
  device: 'Device',
  printer: 'Printer',
  omnivoreHealthy: 'Omnivore health',
  degraded: 'Degraded',
  posHealthy: 'POS health',
  diagnosisDevice: 'DEVICE',
  diagnosisDeviceStatus: 'DEVICE_STATUS',
  diagnosisPrinter: 'PRINTER',

  // table instructions
  moveInstruction1: '1. Please select one or more seats.',
  moveInstruction2: '2. Press move.',

  speedSeatInstruction1: '1. Select the seats to be occupied.',
  speedSeatInstruction2: '2. Press done.',

  occupyingSeats: 'Occupying seats',
  speedSeatDone: 'Done',
  seatAll: 'Seat all',
  moveSeat: 'Move',

  viewDetails: 'View Details',
  checkHistoryHeader: 'Check History',

  menuCart: 'CART',
  confirmMenuClose: 'This will clear the orders. Do you want to continue? ',

  // user permission denied messages.
  never_ask_again_message:
    'You have previously declined this permissions. You must approve this permissions in the app settings.',
  never_ask_again_heading: 'Permissions declined',

  denied_message: 'Please grant all permissions to continue',
  denied_heading: 'Permission not granted',

  emptyMenuCategoriesContent: 'Menu not loaded. Please reopen the menu after sometime.',
  menuItemsEmptyContent: 'No items found',

  receipt_phone: 'phone',
  receipt_email: 'email',
  receipt_paper: 'paper',
  receipt_none: 'none',

  no_tip: 'Cash tip',

  sectionPaid: 'PAID',
  sectionTable: 'TABLE',
  sectionSeat: 'SEAT',

  // Stage payment cash screen
  collectCashHeading: "You're all done!",
  collectCashMessage: 'Thank you! Come back soon.',

  // scan barcode screen
  heading: 'Fit the barcode completely into the box below.',

  discount: 'DISCOUNT',
  discountLbl: 'Discount',
  discountHeader: 'DISCOUNT',

  changeCancel: 'CANCEL',
  changeDone: 'DONE',
  changeLbl: 'CHANGE',
  changeTotal: 'Total:',

  // Donation
  donation: 'Donation',
  DonationCustomDonation: 'custom-donation',
  DonationTotalDonation: 'total-donation',
  DonationRoundUp: 'ROUND UP',
  DonationDollar1: 'DONATE $1',
  DonationDollar5: 'DONATE $5',
  DonationSkip: 'Skip Donation',
  DonationCustom: 'CUSTOM $',
  DonationTotal: 'NEW TOTAL $',
  DonationErrorMessage: 'Enter valid donation',
  DonationMessage: ' Donate and support our charity partner',
  DonationDescription: 'Would you like to donate to our cause today?',

  // DonationModalContent
  DonationCustomAmount: 'I want to pay a donation of',
  DonationTotalAmount: 'Including donation, I want to pay',
  DonationPay: 'Donate & Pay',
  CharityPay: 'PAY',
  CharitySkip: 'SKIP',
  CharityClear: 'CLEAR',
  // guest survey
  surveyLoading: 'Loading survey',
  surveyThankYou: 'Thank you for responding to our survey',
  surveyNotFound: 'Survey not found',
  checkReview: 'Please review your check and select how you would like to pay',

  surveyPrevious: 'Previous',
  surveySkip: 'Skip',
  surveyNotePlaceholder: 'Type here....',
  surveyLabel: 'Please enter your comment',

  customServerMessage: 'Signature',
  clearCustomMessage: 'Clear',
  doneCustomMessage: 'Done',
  customServerTextColors: 'Text Colors',
  messageUpload: 'Uploading message',
  messageUploadError: 'Error in uploading image',

  customTipHeading: 'Thank You for Tipping!',

  tableOccupied: 'This table is already occupied.',

  unmergingTable: 'Unmerging table',
  mergeTable: 'MERGE',
  mergeDone: 'Done',
  mergeCancel: 'Cancel',
  mergingTable: 'Merging table',

  reactivate: 'REACTIVATE',
  reactivateOk: 'OK',

  surveyCommentsTitle: 'Please enter your comments',

  reactivateLoading: 'Reactivating device',
  reactivateHeader: 'Enter new activation code to reactivate the account',

  menuSearchTitle: 'Enter the search text',

  customServerOk: 'OK',

  selfieCancel: 'CANCEL',
  takeSelfie: 'TAKE SELFIE',
  selfieEnableMessage: 'Enable selfie ?',

  customMessageClearHeading: 'Do you want to clear the message ?',
  customMessageClearMessage:
    'Clicking OK will clear the current message. Would you like to proceed ?',
  start: 'START',
  dineIn: 'Dine-In',
  payDonation: 'Adding donation',
  postingTip: 'Posting Tip',
  uploadingPicture: 'Uploading picture',
  enterMobNum: 'Enter your mobile number',
  mobInfo: 'The mobile number is to send notification and not used for any other purpose.',
  go: 'GO',
  orderOpenPopup: 'Creating Order',
  validateOrderPopup: 'Validating Order',
  statusCheck: 'Status Check',
  statusError: 'Unable to connect server',
  syncError: 'Sync Failed',
  myCart: 'My Cart',
  totalAmount: 'Total Amount',
  send: 'SEND',

  kioskAddOrderSpinnerHeading: 'Adding order',
  kioskPriceCheckSpinnerHeading: 'Finalizing cart', // 'Totaling the items in your cart',
  pendingOrderCheck:
    'There is a pending order with this phone number. Do you want to continue with that order?',
  continue: 'Continue',
  orderOpenInfo: 'Preparing Order',
  transaction: 'Transaction Complete',
  gatewayLogin: 'Logging into gateway',
  process: 'Processing',
  itemRemoval: 'This will remove the item from cart',
  removeText: 'Remove item',
  addMore: 'Add More Items',

  signHere: 'Sign Here',
  next: 'NEXT',
  orderPlaced: 'Order Placed!',
  foodPrepare: 'Your Food is being prepared!',
  receiveTextMessage: 'You will receive a text message with instructions to find your table',
  checkout: 'Checkout',

  // Pair Watch
  invalid_data_return: 'Invalid Data',
  pairing_failed: 'Pairing Failed',
  orderAuth: 'Please review your order and click pay to continue.',
  kioskEmptyModifier: 'Item has no modifiers',
  guestNotFound: 'You are not subscribed yet. Would you like to subscribe and continue',
  guestNotSubscribed: 'You are not subscribed yet. Would you like to subscribe and continue',

  // kioskModifiers
  no_calories: 'no calories',
  no_description: 'no description',

  // kiosklanding
  standard_charges: 'Standard message and data rates apply.',
  pnone_number_use:
    'We will only use your cell number for communication related to this order. Your cell number will not be saved or shared for future use.',
  cell_number: 'Please enter your cell number',
  country_code: 'Country Code',
  landing_next: 'Next',
  invalidPhoneNumber: 'The number entered was invalid.',
  cancelText: 'Cancel',
  newTotal: 'NEW TOTAL:',
  // logout
  enterEmpId: 'Enter your Emp ID to logout.',

  // kiosk header
  cancelOrder: 'CANCEL ORDER',

  // loyalty
  terms: 'Accept the terms and conditions',
  gettingOffers: 'Getting offers',
  validatingOffer: 'Validating offer',
  addingLoyalty: 'Adding loyalty',
  deletingLoyalty: 'Removing loyalty',
  phonePlaceholder: 'Enter Phone Number',
  emailPlaceholder: 'Enter Email Id ',
  couponIdLabel: 'Enter your coupon ID',
  addLoyalty: 'ASSIGN TO SEAT',
  deleteLoyalty: 'CLEAR FROM SEAT',
  offersLabel: 'Offers & Coupons',
  check: 'CHECK',
  apply: 'APPLY',
  getOffers: 'GET OFFERS',
  validCouponMessage: 'Enter a valid coupon',
  otherOffersMessage: 'or select from below offers',
  kioskMenuSelectorText: 'Which menu would you like to order from?',
  acceptText: 'We Accept',
  loyaltyRemoveConfirmMessage: 'This will remove the loyalty from your seat',

  errorTeamCheck: 'Not authorized to edit this check',
  checkListEmptyMesage: 'No check found',

  pairWatchError: 'Please scan valid QR code from OneDine watch',
  logoutPopupHeading: 'Do you want to continue?',
  logoutPopupMessage:
    'This will clear all items and cancel your transaction. Do you want to continue?',
  gettingEmployeeChecks: 'Getting employee checks',
  tableNumberInput: 'Please enter table number',
  searchTable: 'Search',
  showCheckLabel: 'Show All Checks',
  subscribePopupHeading: 'Subscribe',
  // deleteLoyalty: 'Delete Loyalty',
  closeMenuPopupHeading: 'Please Confirm',
  emptyOffersListMessage: 'No offers found',
  stagePaymentErrorHeading: 'Error',
  confirmTipPopupHeading: 'Confirm Tip',
  selectMadatory: 'Please select the mandatory modifiers',

  orderMenuItem: 'ADD TO ORDER',
  modifyMenuItem: 'MODIFY / REMOVE',
  removeMenuItem: 'REMOVE',

  // tableTop
  yourOrderPlaced: 'Your order has been placed.',
  selectReceiptType: 'Please select a receipt option.',
  validTableNumber: 'Please enter valid table number',

  // PaymentPay
  serviceCharge: 'Surcharge',
  NFCInvalid: 'The QR code you scanned doesn\t seem to belong to OneDine',
  NFCPay: 'NFC PAY',
  folio: 'Folio',
  folioPayment: 'Folio Payment',

  mergeLimitCross: 'Merge is not allowed as the total seats crosses the limit',
  qrScan: 'Scan QR',
  nfcTap: 'Tap NFC',
  tableTurnNotFound: 'Tableturn is not found',
  noStationError: 'No station found',
  noOptions: 'No options available',
  basicSurveyQuestion: 'How was your experience ?',
  kioskMode: 'Kiosk',
  applyFilters: 'Apply filters',

  printAll: 'PRINT ALL',
  printLoading: 'Printing data',
  somethingWrong: 'Something went wrong',

  // Inactivity Check
  inactiveHeading: 'Are you still there?',
  inactiveMessage: 'Your order is about to be cancelled due to inactivity',
  continueOrder: 'Continue Order',
  newOrder: 'New Order',
  choosePaymentMode: 'How would you like to pay?',
  tipSummaryOnTotal:
    'Tip is calculated on total amount after tax but prior to discounts and service charges',
  tipSummaryOnSubTotal:
    'Tip is calculated on total amount before tax but prior to discounts and service charges',
  kioskTipSummaryOnSubTotal:
    'Tip is calculated on total amount before tax but prior to discounts and service charges',
  cardLabel: 'WE ACCEPT',
  insertCardLabel: 'Insert Card',
  or: 'or',
  tapToPay: 'Tap to Pay',
  retryText1: 'Please Try',
  retryText2: 'Another Form',
  retryText3: 'Of Payment',
  approved: 'Approved',
  removeCardMessage1: 'Please',
  removeCardMessage2: 'Remove',
  removeCardMessage3: 'Card',

  fireboardCheckLabel: 'Check',
  sales: 'SALES',
  fireboardTip: 'TIP',
  fireboardTipInPercent: 'TIP %',
  checkOpen: 'OPEN:',
  checkClosed: 'CLOSED:',

  // kioskTip
  changeTip: 'CHANGE TIP',
  tipAuth: 'Tip could not be authorized',
  newTip: 'New Tip',
  noTip: 'No Tip',
  notification: 'Notification',
  changePrinterUpperCase: 'CHANGE PRINTER',
  coundNotPrint: 'Could not print…Retry or Cancel',
  servicesCharge: 'Service charge',
  skipDonation: 'SKIP DONATION',
  payAnAmountLable: 'Please enter the amount you would like to pay and touch PAY to continue',
  multiplePaymentsLabel:
    'Please enter the amount you would like to pay with this form of payment and touch PAY to continue',
  confirmTip: 'CONFIRM',
  serviceCharges: 'Service Charge',
  paymentIsComplete: 'Your payment is now complete.',
  great: 'It was great serving you!',
  handTo: 'PLEASE HAND TO THE NEXT GUEST',
  payCash: 'Please Pay Cash Directly To Your Server',
  notFound: 'Employee Not Found',
  loyaltyMessage: 'Would you like to join our loyalty program today?',
  notNow: 'Not Now',
  alreadyMember: 'Already a Member',
  joinNow: 'Join Now',
  sim: 'SIM',
  loyaltyLookup: 'How would you like to look up your account?',
  lookupTypeMsg: 'How would you like to check balance?',
  loyaltyAddValueMsg: 'How would you like to add value to your card?',
  loyaltyLookupMsg: 'How would you like to enter your gift card number?',
  loyaltySignup: 'How would you like to enter your loyalty number?',
  loyaltyJoin: 'How would you like to join?',
  phoneNumber: 'Phone Number',
  emailAddress: 'Email Address',
  ors: 'OR',

  checkModifiedText: 'Check has been modified',
  yesCaps: 'YES',
  noCaps: 'NO',
  phoneNumberErrorMessage: 'Phone number is invalid. Please check and try again',
  phoneSubscriptionInfo: 'You will receive a text with a link to your receipt.',
  stageSeat: 'Seat #',
  completePayment: 'COMPLETE PAYMENT',
  cancelPayment: 'CANCEL PAYMENT',
  continueRegularFlow: 'CONTINUE',
  signingHere: 'By signing here, I agree to pay',
  cardIssuer: 'according to my card issuer agreement.',
  moveToEmptySeatError: 'Cannot move discounts to an empty seat',
  moveAllSeatItemsError: 'Cannot move all items from seat',

  // kiosk modes
  selfService: 'Self-service kiosk',
  tableTop: 'Table-top kiosk',

  // speed ordering
  delivered: 'DELIVERED',
  runner: 'RUNNER',

  payNow: 'PAY NOW',
  payLater: 'KEEP OPEN',

  authSuccessful: 'HOLD SUCCESSFUL',

  goBack: 'BACK',

  printing: 'PRINTING',

  speedOrderEmpty1: 'Menu not loaded.',
  speedOrderEmpty2: 'Please reopen after sometime.',
  checkOut: 'CHECKOUT',
  delete: 'DELETE',
  moveError: 'Unable to move items from both modes at once',
  emptyCheckout: 'Cannot checkout with empty cart',
  speedMoveHeader: 'Select the mode to move the items',

  seatNegativeTotalError: 'Cannot make payments when seats have a negative balance',

  preAuth: 'PRE AUTH',

  doubleFlagCheckError: 'Cannot enable printerSupport and jobGroups at a time',
  batteryWarning1: 'LOW BATTERY - PLEASE CHARGE TABLET',
  batteryWarning2: 'OUT OF BATTERY - PLEASE CHARGE IMMEDIATELY',

  fullyCharged: 'FULLY CHARGED',
  charging: 'CHARGING',

  attention: 'ATTENTION',
  tipError: 'The tip amount entered ',
  tipErrorContinuation: ' is greater than 50% of the total bill.',
  changingPrinter: 'Changing printer',

  emptyItems: 'No items for this category',
  nextForm: 'PAY WITH NEXT FORM OF PAYMENT',
  notAtAllLikely: 'Not at all likely',
  extremelyLikely: 'Extremely likely',
  enablePreAuthForTables: 'Enable Preauth for Tables',
  enablePreAuthForTabs: 'Enable Preauth for Tabs',
  preAuthCheckAmount: 'Preauth Check Amount',
  preAuthAmount: 'Please Enter the Preauth Amount.',
  enableTip: 'Enable Tip',
  tipPercent: 'Tip Percent',

  loyaltyOTPHeading: 'Please check your email/phone and enter the four digit code below',

  loyaltySuccess1: 'You have successfully added loyalty to your seat',
  loyaltySuccess2: 'Login to apply the loyalty',
  loyaltyNotNow1: "You don't have any loyalty added to your seat",

  loyaltyEmailText: 'Enter Email Address',
  loyaltyPhoneNumberText: 'Enter Phone Number',
  loyaltyScanText: 'Scan Code',
  loyaltySwipeText: 'Swipe Card',
  loyaltyCardType: 'Number or Code',
  loyaltyEnterText: 'Card number',
  loyaltyPhoneMessage: 'To add loyalty, enter your phone number.',
  loyaltyEmailMessage: 'To add loyalty, enter your email address.',
  // Gift card
  checkBalance: 'Check Balance',
  addValue: 'Purchase or Add Value',

  cardNumberEnter: 'Card number:',
  cardNumberGiftCard: 'Gift card number:',
  cardNumberLoyaltyCard: 'Loyalty card number:',
  securityCodeEnter: 'Security code:',
  optionalSecurityCode: 'Security code (optional):',
  loyaltyCardTypeMessage: 'To add loyalty, enter your card number',
  giftCardNumber: 'Gift Card Number',
  availableBalance: 'Available Balance',
  enterGiftCardAmount: 'Please enter the gift card amount',
  enterCardAmount: 'Please enter the card amount',

  giftCardPaymentInitMessage: 'Initializing payment',
  giftCardPaymentCompleteMessage: 'Completing payment',
  loyaltyInitMessage: 'Initializing loyalty process',
  loyaltyLookupMessage: 'Fetching data',

  selectStationName: 'Select a station',
  noModifiers: 'No Modifiers',
  noItems: 'No Checks Found',

  gettingGiftCardBalance: 'Getting card balance',
  cardDetails: 'Card Details',
  insufficientBalance: 'Insufficient balance to pay tip',
  tipMaximum: 'Available balance : $',
  tipMaxLimit: 'Cannot enter tip amount greater than maximum balance available',
  cardBalanceTypeError: 'Unable to proceed with this card',
  cardValidateLoading: 'Validating gift card',

  loyaltyCompleteLoadingHeading: 'Completing loyalty process',
  powerButtonText: 'This device has not been rebooted since',
  timeSinceLastReboot: 'Time since Last Reboot',
  rebootText:
    'This device needs to be rebooted for OneDine to work optimally. Please click the restart button to reboot the device.',
  unableToReboot: 'We are unable to reboot. Please use the power button',
  supportCall: 'FOR SUPPORT',
  forSupport: 'For Support',
  cannotBeUsedText: 'OneDine can not be used until you restart',
  pointsEmptyMessage: 'No points found',
  restart: 'RESTART',
  totalAmountError: 'Total Amount is 0',
  insufficientbalanceAmount: 'Insufficient balance',
  authCancel: 'Initializing Cancel Payment',

  accessbilityMsg:
    'You will be redirected to the settings page. You may need to scroll down to search for OneDine, please enable permissions to access.',
  accessbilityHeading: 'ENABLE ACCESSBILITY PERMISSION',
  cardNumberText: 'Please enter the card number.',
  securityCodeText: 'Please enter the security code (optional).',
  giftCardActive: 'ACTIVE',
  giftCardInactive: 'NOT ACTIVE',
  currentVersion: 'Current Version',
  deviceActivatedFor: 'Your device is now activated for',
  storeNumber: 'Store Number',
  storeName: 'Store Name',
  address: 'Address',
  updatingAppTo: 'Updating app to',
  Version: 'version',
  appInstallError: 'App installation failed. Please try again.',
  installingApp: 'Installing app',
  scanAnother: 'SCAN ANOTHER',
  purchaseSuccess: 'Purchase Successful!',
  checkMode: 'Order type',
  surveyOptions: 'Survey',
  enterLocation: 'Please enter your location',

  textOk: 'Ok',
  giftCardInsufficientBalance: 'There is no gift card balance to pay the total due amount.',
  savingChanges: 'Saving Changes',
  updateSuccess: 'Updated Successfully!',

  totalDue: 'TOTAL DUE: $',
  subTotalWithDollar: 'Subtotal | $',
  discountWithDollar: 'Discount | $',
  each: 'each',
  balance: 'BALANCE',
  checkReviewBeforePay: 'Please review your check and touch PAY when ready',
  checkReviewBeforeCashPay: 'Please review your check and touch CONFIRM when ready',
  payWithPreAuthCard: 'PAY WITH PRE AUTH CARD',
  loyalty: 'LOYALTY',

  processingSmall: 'Processing...',
  hold: 'Hold',
  signatureFooter1: 'By signing below, I agree to pay $',
  signatureFooter2: 'according to my card issuer agreement.',
  to: 'to',
  payWithDollar: 'PAY $',
  allPaymentsComplete: 'All payments are now complete',
  comeBackVisitAgain: 'Come back to see us \nagain soon',
  receiptSmall: 'Receipt',

  cc_jcb: 'JCB',
  cc_amex: 'AMEX',
  cc_visa: 'VISA',
  cc_dn: 'DN',
  cc_discover: 'DISCOVER',
  cc_mc: 'MC',
  paidItemsMove: 'Paid Items cannot be moved.',
  sharedCheck: 'Shared checks',
  myChecks: 'My checks',
  myChecksCapitalize: 'My Checks',
  confirmationMessage: 'Confirmation Message',
  takeOutCashMessage: 'Collect Cash Payment',
  speedOrderCardPaymentComplete: "Payment of $'{{total}}' is complete.",
  collectCash: 'Please collect cash $',
  tipTooltipInfo: 'Tip is calculated on credit card and gift card payments',

  // Tip second half content
  tipContent:
    ' If you do not want to tip this amount, please re-enter your selection or select a different option on the right.',

  pendingLookupHeader: 'There is a pending card transaction...Please select an option',
  pendingCancelHeader: 'Are you sure',
  pendingCancelMessage:
    'This will cancel the authorization. Please make sure you have an alternate method of payment',
  paymentTimedOut: 'Payment Timed Out',
  remainingBalance: 'Remaining Balance',

  loyaltyErrorForTable: 'Loyalty is not supported for table payment',
  loyaltyErrorMessage: 'Loyalty is not supported for this payment',
  enableMessage: 'Enable message ?',

  errorLoadingCustomProfile: 'Error loading image',
  greatNews: 'Great news [Vance], there are offers you can use today!Please choose one:',
  newTotalText: 'New total Due:$',
  inValue: 'in value',
  doNotUse: 'Dont use any offers today',

  offersHeading1: 'Please choose an offer',
  skipOffers: 'SKIP OFFERS',
  redeemOffer: 'REDEEM OFFER',
  applyingOffer: 'Applying offer',

  reason: 'Reason:',

  noOffers: 'We could not fetch any offers',

  addingStageLoading: 'Staging seat(s)',
  removeStageLoading: 'Removing stage(s)',

  addLoyaltyText: 'ADD LOYALTY',

  paymentComplete: 'This payment is now complete.',
  seeYouAgain: 'Come back to see us \nagain soon',
  cancelPaymentMessage: 'User initiated void',
  addItems: 'ADD ITEMS',
  serverCall: 'CALL SERVER',
  updatingCart: 'Updating cart',

  server: 'Server: ',
  gateway: 'Gateway: ',
  cardType: 'Card Type: ',
  cardNumber: 'Card #: ',
  tipSubTotal: 'Sub Total: ',
  tipTax: 'Tax: ',
  tipAdjustAmount: 'Tip Adjust Amount: ',
  memo: 'Memo: ',
  tipSubmit: 'SUBMIT',
  addMemo: 'Add Memo',
  voidTtransaction: 'Void Transaction',
  assignEmployeeCard: 'Assign Employee Card',
  tipAdjust: 'Tip Adjust',
  saveConfig: 'SAVE',
  appDownloadingText: 'Please wait while the update is downloading…',
  syncChecks: 'Sync Check',
  reopenCheck: 'The check sync is successful. Please re-open the check',
  menuResync: 'Menu is not loaded. Please resync to get the updated menu.',
  resyncMenu: 'ReSync',
  menuNotFound: 'Menu data is not available',
  networkDown: 'Network is down. Please check the network and try again',
  managerLogin: 'LOGIN',
  managerLoginHeader: 'Login',
  enterUsername: 'Please enter your username',
  enterPassword: 'Please enter your password',
  username: 'username',
  password: 'password',
  kioskTipAdded: 'tip was added to your transaction.',
  kioskNewTotal: 'Your new total is',
  kioskTotalCharged: 'The total charged to your card remains',
  kioskCashTip: 'CASH TIP',
  tipWish: 'You wish to pay a total of',
  wish: 'You wish to tip',
  ofThe: 'of the subtotal.',
  doNotWish:
    ' If you do not want to tip this amount, please select a different option on the right.',
  signatureUploading: 'Uploading Signature',
  cartUpdate: 'Updating Cart',
  menuChange: 'CHANGE MENU',

  newTotalMessage: 'Your new total is ',
  tipTotalMessage: 'The total charged to your card remains ',
  gratuity: 'Gratuity: ',
  gratuityPostMessage: 'This will post the payment to the card on file - continue?',
  preAuthPay: 'Pay',
  completingPayment: 'Completing Payment...',
  receiptSentSuccessfully: 'Receipt Sent Successfully',

  enable: 'Enable',

  syncFailed: 'sync failed - please login to continue',
  rethinkErrorLog: 'Error connecting to sync service',
  rethinkNotificationsError: 'Error in getting notifications',
  checksLength: 'Checks length is ',
  notificationLength: 'Notifications length is ',
  tabDisabledLog: 'Tab is disabled as job does not allow Tab',
  noJobGroups: 'Tab is disabled as there are no job groups available',
  mergeLimitExceeded: 'Merge is not allowed as the total seats crosses the limit',

  rethinkConnectionError: 'Error connecting to sync service',
  usingRedis: 'Using socket for subscription',
  usingRethink: 'Using rethink for subscription',
  rethinkConnected: 'Connected to DBManager mode',
  rethinkWarning: 'Connection to DBManager is lost',
  menuSyncError: 'Error syncing menus',

  recheckPermissions: 'Recheck permissions',
  gettingData: 'Getting Data...',
  searchFilter: 'Filtering menus by searchId',
  infoID: 'INFO',
  jobFilter: 'Filtering menus with jobId',
  warnID: 'WARN',
  noMenuAssociated: "There are no menu's associated to the job Id of loggedin employee",
  unsentItemsOpenMessage:
    'Some of the items in the order have been recently received by the POS. Sending them again may create a duplicate order. Please review the order before you send.',
  unsentItemsSendMessage:
    'Some of the items in the order have been recently received by the POS and may create a duplicate order. Do you still want to send all items, remove duplicates or review the check?',
  review: 'REVIEW',
  useBalance: 'Do you want to use the balance of ($',
  towardsCheck: ') towards the check?',
  loggingIn: 'Logging into',
  printingDataAt: 'Printing data at',
  printingData: 'Printing data',
  addingItem: 'Adding item to cart',
  itemAdded: 'Item added to cart',
  payIngenicoSuccess: 'Ingenico message for auth completed',
  transactionComplete: 'Transaction Complete',
  initializingPayment: 'Initializing',
  paymentString: 'Payment',
  loggingInto: 'Logging into',
  gatewayString: 'Gateway',
  enablePreAuth: 'Enable/Disable Pre Auth',
  folioSeats: 'Seats:',
  assignFolio: 'ASSIGN FOLIO',
  reprintReceipt: 'REPRINT RECEIPT',
  checkNo: 'Check No',
  authCode: 'Auth Code',
  managerCardNumber: 'Card Number',
  managerName: 'Name',
  managerPaymentTotal: 'Payment Total',
  managerTip: 'Tip %',
  paymentFailure: 'Payment Failure',
  totalDueLowerCase: 'Total Due: $',
  totalDueWithoutDollar: 'TOTAL DUE',
  paymentTimeout: 'Payment timed out',
  downloadError: 'Download error. Please retry.',
  thankyouMsg: 'Thank you',
  swipeLoyaltyCard: 'Please swipe your loyalty card after the beep',
  holdStatement:
    'A hold has been placed on your card. I agree to settle my tab before departing this establishment for the final check amount.',
  holdOf: ' A hold of',
  holdSubText:
    'has been placed on your card. I agree to settle my tab before departing this establishment for the final check amount.',
  leaveWithout:
    'If I leave without settling my tab, I agree to allow this establishment to settle my final bill amount plus a',
  gratuityText: 'gratuity to this card.',
  establishment:
    'If I leave without settling my tab, I agree to allow this establishment to settle my final bill amount.',
  agreeTo: 'AGREE',
  scanError: 'Error scanning code',
  authorizedOnly: 'Authorized only',
  saleTip: 'Sale Tip transaction is supported for table',
  onGoingSurvey: 'Ongoing Survey is supported for table',

  employeeNotFound: 'Employee not found',
  anyItems: 'Select any number of items',
  selectUpTo: 'Select up to',
  items: 'items',
  atLeast: 'Select at least',
  selectText: 'Select',

  pendingTransactionHeader: 'Complete Pending Transaction',
  pendingTransactionMessage1: 'Do you want to complete the pending transaction for $',
  pendingTransactionMessage2: 'using card ending in',
  rethinkErrorMsg: 'Sync service error',

  printWithStation: 'Printing data at',

  beverageCount0_1: 'Please select at least',
  beverageCount0_2: 'beverages',
  beverageCountInsufficient_1: 'Please select',
  beverageCountInsufficient_2: 'more beverages',
  selectBeverageForSeat: 'Please select beverages for seat',
  selectBeverageForSeats: 'Please select beverages for seats',
  fullCheckMode: 'Paying through full check mode for table',
  multiplePaymentsMode: 'Paying through multiple payments flow for table',
  payAnAmountMode: 'Paying through Pay an amount flow for table',
  splitPayMode: 'Split with others flow for table',
  amountLabel: 'Amount',
  paymentThroughPreAuth: 'Payment through PreAuth Card for table',
  ticketIdLabel: 'Ticket Id :',
  paymentThroughCreditCard: 'Credit card mode payment for table',
  charitySupported: 'Charity is supported for table',
  giftCardMode: 'Payment through Gift card mode for table',
  cashModePay: 'Payment through Cash mode for table',
  offersAvailable: 'Offers available for table',

  thirdPartyPayment: 'TP-PAY',
  submit: 'SUBMIT',
  thirdPartyPaymentHeading: 'Please select a tender from the list',
  submitTender1: 'This will post the payment to',
  submitTender2: 'tender type.\n Do you want to continue?',
  postingCashPayment: 'Posting payment',

  giftCardBalLoader: 'Getting card balance',
  paymentDoneSuccesssfully: 'Payment Successful',
  clickNext: 'Please click continue when the next person is ready.',
  curbSideOrder: 'Curbside',
  pendingOrdersFilter: 'Order status',
  orderPending: 'Pending',
  orderReady: 'Ready',
  orderComplete: 'Complete',
  orderError: 'Error',
  order: 'ORDER: ',
  positive: 'Positive',
  negative: 'Negative',
  newTag: 'NEW',
  ready: 'READY',
  onlineOrder: 'Online',
  walkup: 'Walk up',
  prepTime: 'Prep Time',
  production: 'Production',
  orderTypeAll: 'All',
  customPriceHeader: 'Enter the price',
  currentOrder: 'Current',
  futureOrder: 'Future',
  orderCancel: 'X',
  updateOrderLoading: 'Updating the order status',
  cancelOrderText: 'Cancelled',
  allChecks: 'All checks',
  textToPay: 'TEXT PAY',
  textToPayMessage: 'Text with payment link will be sent to the recipient',
  textToPayHeading: 'Please enter phone number',
  paid: 'PAID',
  itemCount: 'ITEM #',
  orderType: 'Type',
  customer: 'Customer',
  time: 'Time',
  goAndDismiss: 'GO & DISMISS',
  walkUpMode: 'Walk up',
  orderCancellation: 'Order Cancellation',
  textToPayMode: 'Call in',
  orderInProgress: 'In Progress',
  openOrders: 'Open',
  callIn: 'Call in',
  callInCheckDetail: 'Call in:',
  textToPayText: 'TEXT TO PAY',
  requestBtn: 'REQUEST',
  resetBtn: 'RESET',
  callCenter: 'Call Center',
  textToPayGenLoader: 'Generating text to pay',
  payNowLoader: 'Processing request',
  checkInRequestLoader: 'Processing request',
  guestName: 'Please Enter Guest Name',
  guestNameCheckin: 'Please Enter Guest Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  pickupDate: 'Pickup Date:',
  type: 'Type:',
  phnNumberText: 'PHONE: ',
  checkInNote: 'CHECK IN: ',
  rescheduleNote: 'SCHEDULED ORDER IS NOW DUE',
  cashIn: 'CALL IN',
  exampleText: 'For example, to enter 2:30pm, enter 02:30',

  textToPayGenHeading: 'TEXT TO PAY',
  postPayment: 'Posting Payment Link',
  forText: 'for',
  enterPhoneNumber: 'phone number',
  enterPickupTime: 'pickup time',
  enterCheckNumber: 'check number',
  enterSubTotalAmount: 'subtotal amount',
  enterTaxAmount: 'tax amount',
  enterPlease: 'Please Enter',
  placeholderPhone: 'Phone Number',
  placeholderGuest: 'Guest Name',
  placeholderPickup: 'Pickup time(AM/PM)',
  placeholderPickupTime: 'Pickup Time',
  placeholderCheck: 'Check Number',
  placeholderSubTotal: 'Subtotal Amount',
  placeholderTax: 'Tax Amount',
  numberLabel: 'number',
  textLabel: 'text',
  insertCardText: 'insert-card',
  speedOrderCardLabel: 'card',
  nfc: 'nfc',
  orderText: 'Order',
  takeOut: 'TAKE OUT',
  pickUp: 'PICKUP',
  paymentOnly: 'Payment Only',
  sendAndPay: 'SEND & PAY',
  payAtTheRestaurant: 'PAY AT THE RESTAURANT',
  pickupTextToPay: 'CALL IN',
  reviewCheckText: 'Please review your check and select how would you like to pay.',
  orderIsPlaced: 'Order is placed successfully',
  willPost: 'This will send a text to pay request to',
  doYouContinue: 'Do you want to continue?',
  sendACheckinRequest: 'This will send a check-in request to',
  payNowFB: 'PAY NOW',
  payNowHeading: 'SCAN TO PAY',
  checkInRequest: 'CHECK-IN REQUEST',

  orderType_POS: 'POS',
  orderType_Table: 'Table',
  orderType_Tab: 'Tab',
  timePicker: 'Please Select Pickup Time',
  orderType_scanToPay: 'Scan to pay',
  teamShareStationName: 'Station Name',
  goToCheck: 'GO TO CHECK',
  revenueCenterName: 'Revenue Center Name',
  orderTypeName: 'Order Type Name',
  checkNumber: 'Check #',
  tableNumber: 'Table #',
  empName: 'Emp Name',
  pickUpPhone: 'Please Enter Your Phone Number.',
  speedOrder: 'Speed Order',
  orderPay: 'Order Pay',
  payWithQrCode: 'PAY WITH QR',
  giftCardText: 'To add gift card, enter your number',
  enterEmployeeId: 'Please Enter Employee ID.',
  teamShareSearch: 'Please enter search criteria.',
  timepickerPlaceholder: 'Pickup time',
  stageError: 'Cannot stage as you do not have enough seats',
  pickUpText: 'Pick Up',
  takeOutText: 'Take Out',
  searchCriteria: 'Please Enter Search Criteria',

  channelChangeLoader: 'Changing channel status',
  pickupOrder: 'Pick up',
  takeOutOrder: 'Take out',
  teamSearchCriteria: 'Search with Employee, Tab or Table',
  sendSmsMessage:
    'This will send a message to the guest at {{phoneNumber}}.Do you want to continue?',
  guestLabel: 'Guest',
  tablePayConfirmation1: 'The order has been sent.',
  tablePayConfirmation2: 'What would you like to do next?',
  pendingItems: 'There are no pending items in your cart.',
  orderItem: 'ORDER ITEMS',
  viewPay: 'VIEW & PAY',
  addToCart: 'ADD TO CART',
  update: 'UPDATE',
  setting: 'Settings',
  noItemsInCart: 'Payment cannot be made when the cart is empty.',
  speedOrderTabHeading: 'Please Enter Tab Name for Order Pay',
  repeatSpeedOrder: 'Please select an item to repeat.',

  // TableReservation
  floorPlan: 'Floorplan Design',
  config: 'Config',
  waitList: 'Waitlist',
  // FBSettingsHeader: 'Filter Order Modes and Notifications',
  FBSettingsHeader: 'FILTERS',
  FBSettingsOrderModes: 'Order modes: ',
  FBSettingsNotifications: 'Notifications: ',
  iamDone: "I'M DONE",
  payCheck: 'PAY CHECK',

  smdSendLoaderHeading: 'Sending SMS',
  allowScanMessage: 'ID check required to order. Do you want to continue?',
  licenseReader: 'Scan the back of the driver license card',
  verified: 'VERIFIED',
  verifyDetails: 'VERIFY ID DETAILS',

  restrictedItemsClearError:
    'This seat has age restricted items and cannot be cleared. Please move the items to another seat before clearing this seat',
  restrictedItemsMoveError: 'Items cannot be moved to this seat because they are age restricted.',

  fireOrderRejectMessage:
    'Order rejected because of age restrictions.\n Click Manager Approval to continue',
  sendLater: 'SEND LATER',
  managerApproval: 'Manager Approval',
  managerApprovalLoader: 'Sending for manager approval',

  scanLicenseSuccessMsg:
    'Your license has been scanned successfully.\n Please verify your details and click VERIFIED to proceed with your order.',
  scanLicenseErrorMsg: 'Guest does not meet the requirement to order from this category',
  checkSubscriptionError: 'Error on subscribing to check updates',
  searchPlaceholder: 'To search type here',
  deliver: 'DELIVERY',
  syncErrorMsg: 'Unable to open check. Perform at POS',
  pairWatch: 'Pair Watch',
  checkFilter_orderType: 'POS Order Type',
  checkFilter_statusType: 'OneDine Order Type',
  checkFilter_revenueCenter: 'POS Revenue Center',
  settings_check_subHeading: 'Filter Source:',
  settings_subHeading_sourceType: 'Source Types',
  settings_subHeading_orderType: 'Order Types',
  settings_subHeading_revenueCenter: 'Revenue Centers',

  pairWatch: 'Pair Watch',

  underAge: 'UNDER AGE',
  over21: 'OVER 21',
  rejected: 'REJECTED',
  ackIdCheck: 'Acknowledging ID Check',
  ackOverServe: 'Acknowledging Over Serve',

  notification_approve: 'APPROVE',
  notification_reject: 'REJECT',
  notification_acknowledge: 'ACK',

  futureToIPHeader: 'Update Order Status',
  futureToIPMessage: 'Are you sure you want to move the order to In Progress?',

  firstNameLabel: 'First Name : ',
  lastNameLabel: 'Last Name : ',
  phoneNumberLabel: 'Phone Number : ',
  emailLabel: 'Email Address : ',
  logPopup_sync: 'SYNC LOGS',
  logPopup_app: 'APP LOGS',
  logPopup_device: 'DEVICE LOGS',
  tooltip_menu: 'Menu',
  tooltip_logs: 'Logs',

  network_reconnect: 'Reconnect',
  network_restart: 'Restart',
  network_reboot: 'Reboot',
  deliverTo: 'Deliver To',

  moreThanOneLoyaltyError: 'Only one loyalty account can be associated with a payment',
  syncingCheck: 'Syncing check with POS',
  fetchStoreInfo: 'Fetching Store Information',
  activateDevice: 'Activating Device',
  getStoreChecks: 'Getting store checks and menu updates',
  syncCheckMsg: 'This will sync the check with the POS. Do you want to continue?',
  sendOthers: 'Send Others',
  approvalAndSendOthers: 'Send & Approval',
  orientationError: 'Application was unable to start. Click to restart',

  unpaidAmount: 'Unpaid Amount',
  dueAmount: 'Due Amount',
  managerMode: 'Manager',
  goToCheck: 'GO TO CHECK',

  due: 'DUE',
  fetchingStationGroup: 'Fetching station group',
  fetchingStoreLayout: 'Fetching store layout',
  updatingStoreLayout: 'Updating store layout',
  properties: 'Properties',
  noStation: 'No Station Available',
  about: 'About',
  buildVersion: 'Build Version',
  webVersion: 'Web Version',
  environment: 'Environment',
  extensionNotAvailable: 'The extension is not available',

  waitlistTimePicker: "BOOKING TIME",
  waitlistComment: "COMMENT",
  parsingError: 'Parsing Error',
  url: 'URL',
  enterYourLoginId: 'Enter Your Login ID',
  networkLogs: 'Network Logs',
  urlSmall: 'Url',
  request: 'Request',
  response: 'Response',
  paymentProcessed: "payment processed successfully",
  mdmPolicyChangedMsg: "MDM policy updated - application needs to be restarted.",
  logout: 'Logout',
  iAmStillHere: 'I am still here',
  closeApp: 'CLOSE APP',
  inactivityMsg: 'Are you still there? You will be logged out for inactivity in',
  seconds: 'seconds',
  totalSales: 'Total Sales',
  totalTips: 'Total Tips',
  totalTipPercent: 'Total Tip Percent',
  oneDineSales: 'OneDine Sales',
  oneDineTips: 'OneDine Tips',
  oneDineTipPercent: 'OneDine Tip Percent',
  cancelSuccessMsg: 'Order has been cancelled from the Fireboard. Please make sure to cancel it on the POS and process a refund from the portal (if applicable)',
  cancelSuccess: 'Order Cancel Successful',
  splitByPeopleHeading: 'Split By People',
  defaultSplitMessage: 'Cannot reset the split selection. Please Continue to use the split value with which payment is initiated',
  tableView: 'Table View',
  employeeView: 'Employee View',
  assignedEmployees: 'Assigned Employees',
  includeTerminated: 'Include Terminated',
  withSensors: 'With Sensors',
  jobs: 'Jobs',
  assign: 'Assign',
  deliveryToField: 'DELIVER TO: ',
  tableField: 'TABLE: ',
  orderErrors: 'Order Errors',
  viewErrorOrders: 'View Error Orders',
  disabled: 'Disabled',
  enabled: 'Enabled',
  idCaps: 'ID',
  nameLabel: 'Name',
  editLabel: 'Edit',
  orderingEnabled: 'Ordering Enabled',
  foodRunnerDisabled: 'Food Runner Disabled',
  updatingSensorGroup: 'Updating sensor group',
  venueOrderChangeLoader: 'Changing Venue Order Status',
  foodRunnerChangeLoader: 'Changing Food Runner Status',
  updateOrderSettings: 'Update Order Settings',
  mode: 'Mode',
  paid: 'Paid',
  preauth: 'Preauth',
  notifyOrderBeingPrepared: 'Notifying Order Being Prepared',
  notifyOrderReady: 'Notifying Order Ready',
  countryCode: 'Country Code',
  deviceName: 'Device Name',
  disableAutoPrinting: 'Disable Auto Printing',
  orderDate: 'Order Date',
  moveHeldOrderMsg: 'This action will move the order to in-progress immediately. If applicable, it will be sent to the POS. This action cannot be reversed. Do you want to continue?',
  cancelHeldOrderMsg: 'This action will cancel the order immediately. If applicable, the order will not be sent to the POS. This action cannot be reversed. Do you want to continue?',
  uberEats: 'UberEats Marketplace',
  doorDash: 'DoorDash Marketplace',
  doorDashDelivery: 'DoorDash Drive Delivery',
  noteCaps: 'NOTE',
  messageLabel: 'Message',
  issueDate: 'Issue Date',
  eventDate: 'Event Date',
  redeemDate: 'Redeem Date',
  statusLabel: 'Status',
  scanToRedeem: 'Scan to Redeem',
  redeemCode: 'Redeem Code',
  managerOverride: 'Manager Override',
  enterVoucherCode: 'Enter Voucher Code',
  loginLabel: 'Login',
  pleaseMakeASelection: 'Please make a selection',
  tableSensor: 'Table Sensor',
  tableSensors: 'Table Sensors',
  namedSensor: 'Named Sensor',
  namedSensors: 'Named Sensors',
  sensorGroup: 'Sensor Group',
  registerSensor: 'Register Sensor',
  deletingSensor: 'Deleting Sensor',
  addingSensor: 'Adding Sensor',
  redeemVoucher: 'Redeem Voucher',
  typeToRedeem: 'Type To Redeem',
  scanToRedeem: 'Scan To Redeem',
  findVoucher: 'Find Voucher',
  excludeTerminated: 'Exclude Terminated',
  tableWithSensors: 'Table With Sensors',
  jobAllowsAssignment: 'Job Allows Assignment',
  overrideProductionRate: 'Override Production Rate',
  override: 'Override',
  productionRateForToday: 'Production Rate For Today',
  tempOverrideForDay: 'Temp Override For Day',
  clearTempOverride: 'Clear Temp Override',
  editTempOverride: 'Edit Temp Override',
  startTime: 'Start Time',
  endTime: 'End Time',
  clearDefault: 'Clear Default',
  editOverride: 'Edit Override',
  clearLabel: 'Clear',
  saveLabel: 'Save',
  includeOnPremise: 'Include On Premise',
  assigned: 'Assigned',
  pagination: 'Pagination',
  fetchingStoreCubby: 'Fetching Store Cubby',
  moveLabel: 'Move',
  sortByName: 'Sort By Name',
  sortByPOSID: 'Sort By POS ID',
  includeUnavailable: 'Include Unavailable',
  searchWithPosIdOrName: 'Search with POS ID or Name',
  outOfStock: 'Out of Stock',
  reloadOutOfStock: 'Reload Out of Stock',
  cubbyCaps: 'CUBBY',
  lastUpdated: 'Last updated',
  requestRefresh: 'Request Refresh',
  locationUpdate: 'Location Update',
  optionalGuestName: 'Guest Name (optional)',
  updatePhoneNumber: 'Update Phone Number',
  updateGuestInformation: 'Update Guest Information',
  sendSmsPopupMsg: 'This will send an SMS message to the phone number on file. Do you want to continue?',
  ascCaps: 'ASC',
  descCaps: 'DESC',
  sortByTime: 'Sort By Time',
  goToFireboard: 'Go to Fireboard',
  closed: 'Closed',
  allLabel: 'All',
  SvcChg: 'SVC CHG',
  discountAndServiceCharges: 'Discounts and Service Charges',
  sectionView: 'Section View',
  grouping: 'Grouping',
  deviceGroupName: 'Device Group Name',
  empLabel: 'EMP',
  bulkPreAuth: 'Bulk Pre Auth',
  preAuthLabel: 'Pre Auth',
  bulkTextToPay: 'Bulk Text To Pay',
  grubhubMarketplace: 'Grubhub Marketplace',
  seatName: 'Seat Name',
  updateSeatName: 'Update Seat Name',
  updatingSeatName: 'Updating seat name',
  noTablesAvailable: 'No tables available',
  sendPendingItems: 'Sending Pending Items',
  markAgeComplete: 'Marking check as age verification complete',
  enableAgeRestrictedItems: 'Enable Age Restricted Items',
  disableAgeRestrictedItems: 'Disable Age Restricted Items',
  enablingAgeRestrictedItems: 'Enabling Age Restricted Items',
  disablingAgeRestrictedItems: 'Disabling Age Restricted Items',
  enableRestricted: 'Enable Restricted',
  disableRestricted: 'Disable Restricted',
  confirmIDCheck: 'Confirm ID Check',
  clearIDCheck: 'Clear ID Check',
  confirmingIdCheck: 'Confirming ID Check',
  clearingIdCheck: 'Clearing ID Check',
  prepWindow: 'Prep Window',
  overridePrepWindow: 'Override Prep Window',
  overrideProduction: 'Override Production',
  manageOverrides: 'Manage Overrides',
  dayOfWeek: 'Day of the week',
  todaysPrepOverride: "Today's Prep Override",
  todaysProductionOverride: "Today's Production Override",
  pickedUp: 'Picked Up',
  seeCounter: 'See Counter',
  comment: 'Comment',
  overrideReason: 'Override Reason',
  bulkEdit: 'Bulk Edit',
  selectTable: 'Select Table',
  clearingBooking: 'Clearing booking',
  cancelingBooking: 'Canceling booking',
  createBooking: 'Create Booking',
  emailAddressPlaceholder: 'Email Address',
  noteLabel: 'Note',
  creatingNewBooking: 'Creating new booking',
  updatingBooking: 'Updating booking',
  updateBooking: 'Update Booking',
  seatingParty: 'Seating party',
  movingBooking: 'Moving booking',
  selectEmployee: 'Select Employee',
  skip: 'Skip',
  gettingMergedStations: 'Getting merged stations',
  mergingTables: 'Merging Tables',
  unmergingTables: 'Unmerging Tables',
  partiallyPaid: 'Partially Paid',
  unposted: 'Unposted',
  selectTableToMerge: 'Select Table to Merge',
  seatWithoutSelection: 'SEAT WITHOUT TABLE SELECTION',
  seatGuestWithoutSelection: 'Seating Guest without Table Selection',
  movingGuest: 'Moving Guest to a different table',
  selectTableToMove: 'Select Table to Move',
  employee: 'Employee',
  close: 'Close',
  selectACheck: 'Select a check',
  orderType_textToPay: 'Text to Pay',
  staffComment: 'Staff Comment',
  seatSelectedTable: 'Seat Selected Table',
  createWaitList: 'Create Wait List',
  updateWaitList: 'Update Wait List',
  voidingCheck: 'Voiding Check',
  merged: 'MERGED',
  confirmation: 'Confirmation',
  seatGuestMsg: 'Are you sure you want to seat guest without selecting a table',
  mergeTableText: 'This will merge table',
  toTable: 'to table',
  continueText: 'Do you want to continue?',
  sendSms: 'Send SMS',
  sendSmsAll: 'Send SMS to All',
  moveText: 'Move',
  moveAll: 'Move All',
  moveCheckFrom: 'This will move the check from table',
  moveAllCheckFrom: 'This will move all checks from table',
  unmergeTableText: 'This will unmerge table',
  unseatGuest: 'Unseat Guest',
  unseatAllGuest: 'Unseat All Guests',
  moveToWaitList: 'This will move the guest back to the waitlist. Do you want to proceed?',
  cancelWaitlist: 'This will cancel the waitlist for',
  seatParty: 'This will seat the party',
  seatPartyLabel: 'Seat Party',
  returnWaitlistLabel: 'Return to Wait List',
  editWaitlistLabel: 'Edit Waitlist',
  cancelWaitlistLabel: 'Cancel Waitlist',
  smsGuestLabel: 'SMS Guest',
  moveWaitlistLabel: 'Move Waitlist',
  allActions: 'All Actions',
  statusPending: 'Pending',
  statusComplete: 'Complete',
  statusCanceled: 'Canceled',
  phoneLabel: 'Phone',
  partyLabel: 'Party',
  onedineLabel: 'onedine',
  selectSensorGrp: 'Select Sensor Group',
  pleaseSelectLabel: 'Please Select',
  layoutDesignLabel: 'Layout Design',
  sensorLabel: 'Sensors',
  syncCheckLabel: 'Sync Checks',
  aboutLabel: 'About',
  checkDetailsLabel: 'Check Details',
  unmergeTableLabel: 'Unmerge Table',
  clearTableLabel: 'Clear Table',
  transferTableLabel: 'Transfer Table',
  mergeTableLabel: 'Merge Table',
  deleteWaitlistLabel: 'Delete Waitlist',
  reorderWaitlist: 'Reorder Waitlist',
  helpContent: 'Help Content',
  selectedStationToast: 'Selected station cannot be same as move station',
  anotherTableSelect: 'is already occupied! Please select another table',
  selectedStationMergeToast: 'Selected station cannot be same as merge station',
  alreadyMerged: 'is already merged! Please select another table',
  voidCheckLabel: 'Void Check',
  optional: 'Optional',
  addToWaitlist: 'Add to Waitlist',
  enterTableNum: 'Enter Table Number',
  proceedWithoutTableNum: 'Proceed without a table number',
  assignTable: 'Assign a Table',
  guestDetails: 'Guest Details',
  notes: 'Notes',
  contactNum: 'Contact Number',
  assignServer: 'Assign a Server',
  assigningTable: 'Assigning Table',
  clearTableMsg: 'This will clear the table',
  sureToContinue: 'Are you sure you want to continue?',
  clearingTable: 'Clearing the table',
  chooseToMerge: 'Choose the tables to merge',
  textToPaySent: 'Text to pay sent',
  textToCheckInSent: 'Text to check-in sent',
};
